import segmentos_service from "../services/segmentos_service";
export default {
  setSegments: function setSegments(context, query) {
    context.commit('setSegments', query);
  },
  setSegmentEdit: function setSegmentEdit(context, query) {
    context.commit('setSegmentEdit', query);
  },
  setCouponsEdit: function setCouponsEdit(context, query) {
    context.commit('setCouponsEdit', query);
  },
  setAudiencieEdit: function setAudiencieEdit(context, query) {
    context.commit('setAudienceEdit', query);
  },
  setSegmentNew: function setSegmentNew(context, data) {
    context.commit("setSegmentNew", data);
  },
  setCouponsNew: function setCouponsNew(context, data) {
    context.commit("setCouponsNew", data);
  },
  setAudienceHelper: function setAudienceHelper(context, data) {
    context.commit("setAudienceHelper", data);
  },
  setSegmentHelper: function setSegmentHelper(context, data) {
    context.commit("setSegmentHelper", data);
  },
  setCouponsHelper: function setCouponsHelper(context, data) {
    context.commit("setCouponsHelper", data);
  },
  getCompanyFlags: function getCompanyFlags(context, data) {
    segmentos_service.getCompanyFlags().then(function (response) {
      //console.log(response.data)
      if (response.data.length > 0) {
        context.commit("setRequestDataActive", response.data[0].approve_request_data == '1' ? true : false);
        context.commit("setShareAction", response.data[0].share_action == '1' ? true : false);
        context.commit("setGptImages", response.data[0].gpt_images == '1' ? true : false);
        context.commit("setHasTalononeCoupons", response.data[0].talonone_coupons == '1' ? true : false);
        context.commit("setRetailPurchasePrediction", response.data[0].retail_purchase_prediction == '1' ? true : false);
        context.commit("setHasEditSegment", response.data[0].edit_segment == '1' ? true : false);
        // Verificar que response.data[0] existe antes de asignar
        if (response.data[0]) {
          context.commit("setHasEditAudienceTypeGoogleAds", response.data[0].edit_audience_type_google == '1');
        } else {
          context.commit("setHasEditAudienceTypeGoogleAds", false);
        }
      } else {
        context.commit("setRequestDataActive", false);
        context.commit("setShareAction", false);
        context.commit("setGptImages", false);
        context.commit("setHasTalononeCoupons", false);
        context.commit("setRetailPurchasePrediction", false);
        context.commit("setHasEditSegment", false);
      }
    });
  },
  setAudienceImages: function setAudienceImages(context, data) {
    context.commit("setAudienceImages", data);
  },
  setHasTalononeCoupons: function setHasTalononeCoupons(context, data) {
    context.commit('setHasTalononeCoupons', data);
  },
  setRetailPurchasePrediction: function setRetailPurchasePrediction(context, data) {
    context.commit('setRetailPurchasePrediction', data);
  },
  setHasEditSegment: function setHasEditSegment(context, data) {
    context.commit('setHasEditSegment', data);
  }
};